import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ToastProvider } from '@monigo/ui';
import { router } from './router.js';
import { useSession } from '../lib/store/session.js';

export function App() {
  const init = useSession((s) => s.init);
  useEffect(() => {
    void init();
  }, [init]);

  return (
    <ToastProvider>
      <RouterProvider router={router} />
    </ToastProvider>
  );
}
